import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import Point from '../../../Utility/Point';
import { captureException } from '../../../Sentry';
import { Tween } from '@tweenjs/tween.js';
import Container from '../../../Prototype/Container';
import Sprite from '../../../Prototype/Sprite';
import Renderable from '../../../Component/Renderable';
import { AwaitIterators } from '../AnimationHelper';
import Text from '../../../Prototype/Text';
import Game from '../../../Game';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import Scene from '../../../Scene/Scene';
import LevelHelper from '../../../Utility/LevelHelper';
import TextComponent from '../../../Component/Render/Text';

export class LevelCost extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        try {
            const container: Container = GameObject.Instantiate(Container, {
                name: 'cost_container',
                scale: new Point(1.25, 1.25),
                alpha: 0,
            });
            gameObject.addChild(container);
            const containerTransform: TransformComponent = container.getComponent(
                TransformComponent
            );
            const containerRenderable: Renderable = container.getComponent(
                Renderable
            );
            const renderableTween: Tween = this.getTween(containerRenderable);
            const positionTween: Tween = this.getTween(
                containerTransform.position
            );
            const scaleTween: Tween = this.getTween(containerTransform.scale);
            const coin: Sprite = GameObject.Instantiate(Sprite, {
                texture: 'coin_icon',
                alpha: 1,
                anchor: new Point(0.5, 0.2),
                x: -60,
            });
            const popupCostTextComponent = gameObject.getComponent(
                TextComponent
            );
            const levelCost: number = LevelHelper.getLevelEntryCost(
                meta.levelNumber,
                meta.alreadyCompleted
            );
            const text: Text = GameObject.Instantiate(Text, {
                text:
                    levelCost > 0
                        ? `- ${levelCost}`
                        : Game.locale.getText('Free'),
                style: popupCostTextComponent.style,
                x: levelCost > 0 ? -20 : 0,
            });

            //if (levelCost > 0)
            container.addChild(coin);
            container.addChild(text);
            /*
            const pos: PIXI.Point = container.container.getGlobalPosition();
            console.log(pos);
            //containerTransform.position.set(-pos.x, -pos.y); */
            const scene: Scene = Game.scene.getActiveScene();
            scene.addGameObject(container);
            scene.emit(RenderSystemEvent.BRING_TO_FRONT, container);

            containerTransform.position.set(-30, 0);

            positionTween.to({ y: -150 }, 500);
            renderableTween.to({ alpha: 1 }, 150);
            scaleTween.to({ x: 2, y: 2 }, 450);

            yield* AwaitIterators([
                this.startTween(positionTween),
                this.startTween(renderableTween),
                //this.startTween(scaleTween),
            ]);

            /* yield* delay(200);

            renderableTween.to({ alpha: 0 }, 350);
            yield* this.startTween(renderableTween); */
            container.destroy();
        } catch (e) {
            captureException(e);
        }
    }
}
